import React from "react";
import queryString from "query-string";

export default function (Component, ownProps) {
  const Page = props => {
    const {
      location: { search, pathname },
      match,
      history,
    } = props;
    const params = match.params;
    const query = queryString.parse(search);
    const locationState = history.location.state;
    const pushTo = pushProps => {
      history.push({
        pathname: pushProps.path || pathname,
        search: queryString.stringify(pushProps.query || {}, {
          skipNull: true,
        }),
        state: pushProps.state,
      });
    };
    const editable = params.id && match.path.indexOf("edit") > -1;
    return (
      <Component
        {...props}
        id={params.id || ownProps?.id || undefined}
        editable={editable}
        query={query}
        locationState={locationState}
        params={params}
        pushTo={pushTo}
      />
    );
  };
  return Page;
}
